import React from "react"
import { navigate } from "gatsby"

export const LinkToEnter = ({ children, language, destinationURL }) => {
  let location = ""
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href)
    location = url.pathname
  }

  const clickToOpen = ev => {
    ev.preventDefault()
    localStorage.setItem("pricealertsform_callingURL", location)
    navigate(
      language && language !== "en"
        ? `/${language}${destinationURL}`
        : destinationURL
    )
  }

  return (
    <>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          onClick: clickToOpen,
          clickToOpen,
        })
      )}
    </>
  )
}
